// removed by extract-text-webpack-plugin
module.exports = {"SliderPointerDragFix":"ArticleModal-SliderPointerDragFix","DarkNavLink":"ArticleModal-DarkNavLink","ArticleBody":"ArticleModal-ArticleBody"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/theme/News/components/ArticleModal.less
// module id = 117
// module chunks = 0